import {
  ObjectiveInput,
  ObjectivePreservationTargetInput,
} from '@automata/wfb-api/src/apis/wfbApiSchemas';

export const STAGE_TYPE_OPTIONS: {
  value: ObjectiveInput;
  label: string;
  tooltip?: string;
}[] = [
  {
    value: 'makespan',
    label: 'Makespan',
    tooltip: 'Set the target maximum run duration for the entire workflow.',
  },
  {
    value: 'slack',
    label: 'Slack',
    tooltip:
      'Adds buffer time around strict time constraints, to make the workflow more resilient to delays and interruptions.',
  },
  {
    value: 'consistency',
    label: 'Consistency',
    tooltip: 'Reduce variation in planned task timings across batches.',
  },
  {
    value: 'deadtime',
    label: 'Deadtime',
    tooltip:
      'Minimise the time labware spends idle at locations without an active task.',
  },
  {
    value: 'timing_targets',
    label: 'Timing targets',
    tooltip: 'Minimise deviation from the ideal times for each timing target.',
  },
];

const OBJECTIVE_INPUT_VALUES: readonly ObjectiveInput[] = [
  'makespan',
  'deadtime',
  'timing_targets',
  'slack',
  'consistency',
];

export const isObjectiveInput = (value: unknown): value is ObjectiveInput =>
  typeof value === 'string' &&
  OBJECTIVE_INPUT_VALUES.includes(value as ObjectiveInput);

export const CARRY_FORWARD_OPTIONS: {
  value: ObjectivePreservationTargetInput;
  label: string;
  tooltip?: string;
}[] = [
  {
    value: 'same_or_better',
    label: 'Same or better',
    tooltip: 'Future stages can only maintain or improve this stage’s metric.',
  },
  {
    value: 'lock',
    label: 'Lock',
    tooltip: 'This stage’s metric must remain unchanged in future stages.',
  },
  {
    value: 'plus_or_minus_1_percent',
    label: '+/- 1%',
    tooltip:
      'Future stages must keep this stage’s metric within the specified percentage range.',
  },
  {
    value: 'plus_or_minus_5_percent',
    label: '+/- 5%',
    tooltip:
      'Future stages must keep this stage’s metric within the specified percentage range.',
  },
  {
    value: 'plus_or_minus_10_percent',
    label: '+/- 10%',
    tooltip:
      'Future stages must keep this stage’s metric within the specified percentage range.',
  },
];

const CARRY_FORWARD_VALUES: readonly ObjectivePreservationTargetInput[] = [
  'same_or_better',
  'lock',
  'plus_or_minus_1_percent',
  'plus_or_minus_5_percent',
  'plus_or_minus_10_percent',
];

export const isCarryForwardRule = (
  value: unknown
): value is ObjectivePreservationTargetInput =>
  typeof value === 'string' &&
  CARRY_FORWARD_VALUES.includes(value as ObjectivePreservationTargetInput);

export const VALIDATION_MESSAGES = {
  improvementTimerLimit: 'Value must be 0 or greater',
};
